module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Message sent","body":"You\u0027ll receive an e-mail from us shortly and within 2 days you\u0027ll got a response to your message."},"nl":{"title":"Bericht verstuurd","body":"We sturen je nog even een mail ter bevestiging en binnen 2 dagen kun je een antwoord verwachten."}}')
  delete Component.options._Ctor
}
